export enum NtConsentStatuses {
  ALL_TERMS_ACCEPTED_NT_PRESCRIPTION_CONSENT_REQUIRED,
  NT_INSURANCE_CONSENT_REQUIRED,
  NT_INSURANCE_AND_PRESCRIPTION_CONSENTS_REQUIRED,
  ALL_TERMS_ACCEPTED_NT_INSURANCE_CONSENT_REQUIRED,
  NOT_DEFINED
}
